import * as React from 'react';
import Box from '@mui/material/Box';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import {Add, Remove} from '@mui/icons-material'


const actions = [
    { icon: <Add color={"success"}/>, name: 'Add User TO Group' },
    { icon: <Remove color={"primary"}/>, name: 'Remove User From Group' },
];

export const UserGroupEditMenu = ( { user, setSelectedUser, handleShowAddUserToGroupModal, handleShowRemoveUserFromGroupModal }) => {

    const handleOnHover = () => {
        setSelectedUser(user);
    }

    const handleOnLeave = () => {
        // setSelectedUser({})
    }

    return (
        <Box sx={{ transform: 'translateZ(0px)', flexGrow: 1 }}>
            <SpeedDial
                onMouseEnter={handleOnHover}
                onMouseLeave={handleOnLeave}
                ariaLabel="user edit menu"
                sx={{ position: 'absolute', bottom: -25, right: -15 }}
                icon={<SpeedDialIcon/>}
            >
                        <SpeedDialAction key={actions[0].name} icon={actions[0].icon} tooltipTitle={actions[0].name} onClick={handleShowAddUserToGroupModal}/>
                        <SpeedDialAction key={actions[1].name} icon={actions[1].icon} tooltipTitle={actions[1].name} onClick={handleShowRemoveUserFromGroupModal}/>

            </SpeedDial>
        </Box>
    );
}
